import { Provider } from "react-redux";
import { store } from "@redux";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "@contexts/user";
import { AppTheme } from "@contexts/theme";
import AppLocale from "@contexts/locale";
import { AppRouter } from "@contexts/router";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "react-toastify/dist/ReactToastify.min.css";
import "react-multi-carousel/lib/styles.css";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-quartz.css";
import "./App.css";

function App() {
  return (
    <GoogleOAuthProvider clientId="22104640357-fb0iom82u3hod49hukjpajrrnrkbue2b.apps.googleusercontent.com">
      <Provider store={store}>
        <ToastContainer theme="colored" position="top-left" />
        <UserProvider>
          <AppLocale>
            <AppTheme>
              <AppRouter />
            </AppTheme>
          </AppLocale>
        </UserProvider>
      </Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
